import React from 'react';
import {Contact} from '../Types/Contact';

interface ContactCardProps {
  contact: Contact;
  large?: boolean;
}

const getInitials = (name: string): string =>
  name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');

const ContactCard = ({contact, large = false}: ContactCardProps): JSX.Element => {
  return (
    <div className="card border h-100">
      <div className="card-body d-flex align-items-center">
        <div className={`symbol symbol-circle me-5 ${large ? 'symbol-70px' : 'symbol-50px'}`}>
          <span className="symbol-label bg-light-primary text-primary fw-bold fs-3">
            {getInitials(contact.name)}
          </span>
        </div>
        <div className="d-flex flex-column">
          <span className={`fw-bold text-gray-900 ${large ? 'fs-3' : 'fs-5'}`}>{contact.name}</span>
          <span className="text-gray-600">{contact.title}</span>
          {contact.email && (
            <a href={`mailto:${contact.email}`} className="text-primary">
              {contact.email}
            </a>
          )}
          {contact.phone && <span className="text-gray-600">{contact.phone}</span>}
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
